import { coreDataStore } from "../../helper/CoreDataStorage";
import { audio_engine } from "../core/AudioEngine";

export class RegionMusic {
  private sound: Howl;
  private id: number;
  private region: string;
  private priority: number;

  constructor(src: string, regionID: string, priority: number) {
    this.id = Date.now();
    this.region = regionID;
    this.priority = priority;

    this.sound = new Howl({
      src: [src],
      autoplay: false,
      html5: false,
      loop: true,
      volume: 0,
      onload: () => {
        this.start();
      },
    });

    audio_engine.region_sounds.push(this);
  }

  updateVolume() {
    this.sound.volume(audio_engine.music_volume);
  }

  start() {
    const uptime = coreDataStore.core_data?.time ?? 0;
    const duration = this.sound.duration();

    if (!duration || duration <= 0) return;

    const position = (uptime / 1000) % duration;

    this.sound.seek(position);
    this.sound.play();

    this.fadeIn();
  }

  stopClean() {
    this.fadeOut();
  }

  fadeIn() {
    this.sound.volume(0);
    this.sound.fade(0, audio_engine.music_volume, 2000);
  }

  fadeOut() {
    this.sound.fade(this.sound.volume(), 0, 2000);

    setTimeout(() => {
      this.sound.stop();

      audio_engine.region_sounds = audio_engine.region_sounds.filter(
        (r) => r !== this,
      );
    }, 2000);
  }

  getRegionName() {
    return this.region;
  }

  getRegionPriority() {
    return this.priority;
  }

  mute() {
    this.sound.mute();
  }
  unlock() {
    this.sound.mute(false);
  }
}
